import { Box, Circle, Flex, IconButton, Text } from "@chakra-ui/react";
import { FC } from "react";
import PieChartCmp from "../../../components/PieChartCmp";
import { GuestDataItemGrid, GuestInviteStatus } from "../../../types/guest";
import Icon from "../../../components/Icon";
import { useGetGuestInsights } from "../../../apis/guest";



type InviteStatusDetailsProps = {
  count: number;
  inviteStatus: GuestInviteStatus;
};


const InviteStatus: FC<InviteStatusDetailsProps> = ({
count,
inviteStatus,
}) => {
    const StatusMap: Record<GuestInviteStatus, [string, string]> = {
    [GuestInviteStatus.Pending]: ["Pending", "#e0ac2b"],
    [GuestInviteStatus.Accepted]: ["Confirmed", "#54C080"],
    [GuestInviteStatus.Rejected]: ["Declined", "#BB2727"],
  };
  const [, StatusColor] = StatusMap[inviteStatus];

  const textValue = () => {
    switch (inviteStatus) {
      case "reject": 
        return "Declined";
      case "accept":
        return "Confirmed";
      case "pending":
        return "Pending";
    }
  }

  return (
     <Flex justifyContent={"space-between"} py={"16px"}>
       <Flex columnGap={"5px"} alignItems={"center"}>
        <Circle bg={StatusColor} size={"10px"}></Circle>
        <Text> 
          {textValue()}:
        </Text>
       </Flex>
       <Text as={"b"}>
        {count}
       </Text>
     </Flex>
  )
}

type InsightsDrawerProps = {
  onClose: () => void;
};



const GuestInsightsDrawer = ({ onClose }: InsightsDrawerProps) => {
  const { data: insightsData } = useGetGuestInsights({});
  const guestCount = insightsData?.payload?.total ?? 0;
  const acceptCount = insightsData?.payload?.accepted ?? 0;
  const pendingCount = insightsData?.payload?.pending ?? 0;
  const rejectCount = insightsData?.payload?.rejected ?? 0;

  const simpleData: GuestDataItemGrid[] = [
    { name: GuestInviteStatus.Accepted, value: acceptCount },
    { name: GuestInviteStatus.Pending, value: pendingCount },
    { name: GuestInviteStatus.Rejected, value: rejectCount },
  ];


  return (
    <Flex
      w={"full"}
      flexDirection={"column"}
      className={"no-scrollbar"}
      p={{ base: "0.5rem", md: "1.5rem" }}
      rowGap={"3vh"}
    >
      <Flex
        w={"full"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text
          fontWeight={400}
          fontSize={{ base: "20px"}}
          fontFamily={"font4"}
          lineHeight={"2"}
        >
          Guest Insights
        </Text>
        <IconButton aria-label="Close Drawer" icon={<Icon name="close" variant="stroke"/>}
        onClick={onClose} 
        button-data-variant="icon"
        bgColor={"#F9F9F9"}
        />
      </Flex>

      <Flex bg={"rgba(249, 249, 249, 1)"}
            border={"1px solid rgba(229, 229, 229, 1)"}
            w={"full"} p={"12px"} fontFamily={"font4"}
            borderRadius={"16px"} columnGap={"5px"}
            alignItems={"center"}>
        <Icon name="people" variant="stroke"/>
        <Text as={"span"}> No. of Guests: <b>{guestCount}</b></Text>
      </Flex>

      
          <Flex
            w={"full"}
            h={"fit-content"}
            justify={"center"}
            bg={"rgba(249, 249, 249, 1)"}
            border={"1px solid rgba(229, 229, 229, 1)"}
            p={"12px"} fontFamily={"font4"}
            borderRadius={"16px"}
          >
            <PieChartCmp analyticsData={simpleData} borderColor={"white"} size={"180px"} totalValue={guestCount} />
          </Flex>

          <Box bg={"rgba(249, 249, 249, 1)"}
            border={"1px solid rgba(229, 229, 229, 1)"}
            w={"full"} px={"12px"} fontFamily={"font4"}
            borderRadius={"16px"}
            sx={{
              '& > * + *' : {'border-top' : '1px solid rgba(229, 229, 229, 1)'}
            }}>
            {
              simpleData.map(item => 
                <InviteStatus
                count={item.value}
                inviteStatus={item.name}
                key={item.name}
              />
              )
            }
          </Box>
        
    </Flex>
  );
};

export default GuestInsightsDrawer;
